export const SPRIG_LANDS_ON_HOMEPAGE_EVENT_NAME = 'landsOnHomepage';
export const SPRIG_COMPLETED_WITHDRAWAL_FLOW_EVENT_NAME = 'completedWithdrawalFlow';
export const SPRIG_LEFT_WITHDRAWAL_FLOW_EVENT_NAME = 'leftWithdrawalFlow';
export const SPRIG_HAS_PERPS_BALANCE_ATTRIBUTE_NAME = 'hasPerpsBalance';
export const SPRIG_ISOLATED_MARGIN_TRADES_ATTRIBUTE_NAME = 'isolatedMarginTrades';
